import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { FormattedNumber } from 'dibs-react-intl';

import { SharedFormatAmount_financialAmount$key } from './__generated__/SharedFormatAmount_financialAmount.graphql';

type Props = {
    currency: string;
    financialAmount: SharedFormatAmount_financialAmount$key | null;
};
const SharedFormatAmount: FC<Props> = ({ currency, financialAmount: financialAmountRef }) => {
    const financialAmount = useFragment(
        graphql`
            fragment SharedFormatAmount_financialAmount on FinancialAmount {
                amount
                convertedAmountList {
                    amount
                    currency
                }
            }
        `,
        financialAmountRef
    );
    const convertedAmountList = financialAmount?.convertedAmountList || [];
    const amountObj = convertedAmountList.find(a => a?.currency === currency);
    const amount = amountObj?.amount || 0;
    return <FormattedNumber value={amount} style="currency" currency={currency} />;
};

export default SharedFormatAmount;
